import React from 'react'
import './style-selector.css'

const StyleSelector = (props) => {
    const [addLink, setAddLink] = React.useState(false)
    const [quoteFill, setQuoteFill] = React.useState('#fff')

    React.useEffect(() => {
        let position = calculateSidetoSide(props.start)
        let depth = calculateUpDown(props.top)
        document.getElementById("style-selector").style.marginLeft = `${position}px`
        document.getElementById("style-selector-wrapper").style.top = `${depth}px`
    }, [])

    React.useEffect(() => {
        for(let i = 0; i < props.sections.length; i++) {
            if(props.theId === props.sections[i].id) {
                if(props.sections[i].type === 'pullQuote1' || props.sections[i].type === 'pullQuote2' || props.sections[i].type === 'pullQuote3') {
                    setQuoteFill('#B6E5A4')
                }
            }
        }
    })

    const calculateSidetoSide = (start) => {
        return start - 200
    }
    const calculateUpDown = (start) => {
        return start - 78
    }
    return(
        <div className="style-selector-wrapper" id="style-selector-wrapper">
            <div className="style-popup-whole-wrapper">
                <div className="style-selector" id="style-selector">
                    <div className="style-icon-btn bold-icon" onClick={() => props.insertAtCursor('**', null)}></div>
                    <div className="style-icon-btn italic-icon" onClick={() => props.insertAtCursor('*', null)}></div>
                    <div className="style-icon-btn link-icon" id="create-link" onClick={() => props.nowTheLink(props.sectionId)}></div>
                    <div className="style-icon-btn quotes-icon" id="flip-through-pull-quotes" onClick={() => props.setSectionPullQuote(props.theId)}><svg id="flip-through-pull-quotes-svg" version="1.1" x="0px" y="0px" width="20px" height="50px"><path fill={quoteFill} id="flip-through-pull-quotes-svg-path-1" d="M15.48 18.024c-2.603 0-4.45-2.172-4.45-4.778 0-3.263 2.498-6.3 6.517-8.803l1.297 1.303c-2.497 1.63-3.91 3.042-3.91 5.214 0 2.824 3.91 3.582 3.91 3.91.11 1.41-1.194 3.15-3.366 3.15h.004v.004z"></path><path fill={quoteFill} id="flip-through-pull-quotes-svg-path-2" d="M6.578 18.024c-2.606 0-4.453-2.172-4.453-4.778 0-3.263 2.497-6.3 6.515-8.803l1.303 1.303c-2.606 1.63-3.907 3.042-3.907 5.106 0 2.823 3.91 3.58 3.91 3.91 0 1.518-1.304 3.257-3.368 3.257z"></path></svg></div>
                    <div className="style-selector-square"></div>
                </div>
            </div>
        </div>
    )
}
export default StyleSelector;